module.exports = __webpack_public_path__ + "static/media/376.418c192f.png";